import NotifiesView from './NotifiesView';
export default NotifiesView;
